import { useEffect } from "react";

import { useEnvironmentVariables } from "../environment/use-environment-variables";

import { datadogRum } from "@datadog/browser-rum";

export const useEnrichDatadogRUMGlobalContext = () => {
  const data = useEnvironmentVariables();

  useEffect(() => {
    Object.entries(data).forEach((keyValue) =>
      datadogRum.setGlobalContextProperty(...keyValue),
    );
  }, [data]);
};
